export default "__VITE_ASSET__mxVpptXk__"